export const fancyboxx = () => {
  $(".fancybox").fancybox({
    touch: false,
    autoFocus: false,
  });
};
